export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mining Educator — London, United Kingdom',
    'My students finally understand the difference between mineral exploration, mining methods, and mineral processing. I used to waste hours searching for the right way to explain how mining actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Geology Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain underground mining safety, ore deposits, or how to teach decision-making in mining contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Earth Science and Resources Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated mining projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Mining Educator | London, United Kingdom',
    "The material on ore deposits and mineral exploration completely changed how my students understand mining. They finally grasp how mineral resources are discovered and evaluated. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Geology Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Earth Science Teacher | Berlin, Germany',
    "The 50 mining projects transformed how my students see real-world applications. Now they investigate mining methods, analyze environmental challenges, understand processing operations, and grasp why mining knowledge matters professionally and globally. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The mining terminology handbook gave me back my class time. I used to spend time explaining mining concepts and misconceptions. Now I show the handbook and students instantly understand mining concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Mining & Resources Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real mining challenges, evaluating safety concerns, exploring environmental solutions, and understanding how mining fits in modern society. This completely transformed how they see mining and mineral resources.",
  ],
];
